module.exports = __webpack_public_path__ + "media/images/flags/ge-749bd8bdbdce60a022cbc5a0b1273678.svg";